import React, {useState,useEffect} from 'react';
import {SeatLayout} from "./seat-layout.component";
import {getSeatGrid} from "./seat-layout-container.module";
import {SeatLegend} from "./seat-legend.component";
import {LastBookedSeatsComponent} from '../last-booked-seats-component/last-booked-seats.component';
import {NotBoardedSeatsBlock} from './not-boarded-seats.component';
import './seats.style.scss';
import { updateSelectedSeats } from './../../actions/passenger-form.action';
import { useDispatch , useSelector } from 'react-redux';
import { adminBlockTripRouteIdSelector, selectedSeatsSelector } from './../../selector/passenger-form.selector';
import { getJsonKeys, isValid } from '../../utils/utilities';
import { message } from 'antd';
import { GET_TRAVELLER_INFO_TICKETID_AND_SEAT_NUMBER_URL} from './../../utils/api-url';
import{blockedSeatTicketIdSelector} from './../../selector/passenger-form.selector';
import { fetchSeatLayout } from '../../actions/home.action';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

const addBlockedSeat = (ticketId,seatNumber,onSuccess=()=>{

})=>{
    fetch(GET_TRAVELLER_INFO_TICKETID_AND_SEAT_NUMBER_URL, {
        method: "POST",
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify({
            "ticketId" : ticketId,
            "seatNumber" : seatNumber
        })
        })
        .then(response => response.json())
        .then(data =>{
            onSuccess(data);
        }).catch((err)=>{
            console.log({err});
            message.error("Failed to get seater info");
        })
} 

export const SeatLayoutContainer = props => {

    const{
        seatsData,
        noOfSeatsAllowedToClick,
        blockedSeatAllowed,
        onSeatClickSuccess,
        showLegend=true,
        showFarePopOver,
        changeOldLayout = false,
        oldSelectedSeats,
        isDragDropRequired = true,
        // Seat layout change mapping selects seats to MOVE, not to book or release -
        // the "blocked group must be selected together" rules do not apply there.
        skipBlockedGroupValidation = false,
        tripId
    } = {...props};


    const dispatch=useDispatch();
    const selectedSeats=useSelector(selectedSeatsSelector);
    const blockedSeatTicketId=useSelector(blockedSeatTicketIdSelector);
    const adminBlockTripRouteId=useSelector(adminBlockTripRouteIdSelector);

    const [showSeatLayout, updateShowSeatLayout] = useState(false);
    const [seatGrid, updateSeatGrid] = useState([[]]);
    const [notBoardedReloadKey, setNotBoardedReloadKey] = useState(0);

    const reloadSeatLayout=(tripRouteId)=>{
        dispatch(fetchSeatLayout(tripRouteId, (fetchedSeats)=>{
        }, (error)=>{
            message.error('Failed to save changes');
        }));
    }

    const reloadNotBoarded = () => {
        setNotBoardedReloadKey((prev) => prev + 1);
    };

    const onDispatchSeatClick=(object,passengerInfo)=>{
        let selectedSeatCount = getJsonKeys(selectedSeats).length;
        let alreadySelectedSeat = false;
        if(selectedSeatCount>0){
            alreadySelectedSeat = isValid(selectedSeats[object.id])?true:false;
        }
        if(!isValid(noOfSeatsAllowedToClick)||noOfSeatsAllowedToClick>selectedSeatCount||alreadySelectedSeat){
            dispatch(updateSelectedSeats(object.id,object,passengerInfo));
            if(isValid(onSeatClickSuccess)){
                onSeatClickSuccess(object);
            }
        }else{
            message.error(`Maximum seats to select is : ${noOfSeatsAllowedToClick}`);
        }
    }

    const onSeatCLick = (object) => {
        if(noOfSeatsAllowedToClick!=0){
            if(skipBlockedGroupValidation){
                if(isValid(object.ticket_id)&&object.seat_status==="Blocked"&&!blockedSeatAllowed){
                    message.error("Blocked for some other customer");
                }else{
                    onDispatchSeatClick(object,{});
                }
                return true;
            }
            if(isValid(object.ticket_id)&&object.seat_status==="Blocked"){
                if(blockedSeatAllowed){
                    if(!isValid(blockedSeatTicketId)||(blockedSeatTicketId===object.ticket_id)){
                        if(isValid(adminBlockTripRouteId)){
                            message.error("Tickets blocked and admin blocked separately not allowed to book/release together");
                        }else{
                            addBlockedSeat(object.ticket_id,object.seat_number,(passengerInfo)=>{
                                onDispatchSeatClick(object,passengerInfo)
                            });
                        }
                    }else{
                        message.error("Ticket blocked separately not allowed to book together");
                    }
                }else{
                    message.error("Blocked for some other customer");
                }
            }else{
                if(isValid(adminBlockTripRouteId)){
                    if(isValid(object.seatShownPassenger)&&isValid(object.seatShownPassenger.trip_route_id)&&
                    adminBlockTripRouteId==object.seatShownPassenger.trip_route_id){
                        if(isValid(blockedSeatTicketId)){
                            message.error("Ticket blocked and admin blocked separately not allowed to book/release together");
                        }else{
                            onDispatchSeatClick(object,{}); 
                        }
                    }else{
                        message.error("Ticket blocked separately not allowed to book/release together");
                    }
                }
                else{
                    onDispatchSeatClick(object,{});
                }
            }
        }
        return true;
    };

    useEffect(() => {
        if(seatsData !== undefined && seatsData.length > 0) {
            const {
                seatGridLayout
            } = getSeatGrid(seatsData, onSeatCLick, selectedSeats, showFarePopOver, false, changeOldLayout,
                global?.travelsDetails?.both_decks_together, oldSelectedSeats, reloadSeatLayout, isDragDropRequired,
                reloadNotBoarded);
            const seatGridSeats = seatGridLayout.lowerSeatGrid;
            if(seatGridSeats.length > 1) {
                updateSeatGrid(seatGridLayout);
                updateShowSeatLayout(true);
            }
        }
        else {
            updateSeatGrid([[]]);
            updateShowSeatLayout(false);
        }
    },[seatsData,selectedSeats,noOfSeatsAllowedToClick]);

    return (
        <DndProvider backend={HTML5Backend}>
            <div id="seat-layout">
                {showSeatLayout &&
                    <div className="seat-layout-parent-container">
                            <SeatLayout seatGridLayout={seatGrid} changeOldLayout = {changeOldLayout}/>
                    </div>
                }
                {isValid(tripId) &&
                    <NotBoardedSeatsBlock tripId={tripId} seatsData={seatsData} reloadSignal={notBoardedReloadKey}/>
                }
                {showLegend?
                    <div style={{display: 'flex', alignItems: 'flex-start', flexWrap: 'wrap'}}>
                        {isValid(tripId) &&
                            <LastBookedSeatsComponent tripId={tripId}/>
                        }
                        <SeatLegend/>
                    </div>
                    :null
                }
            </div>
        </DndProvider>
    );
};

SeatLayoutContainer.defaultProps = {

};

SeatLayoutContainer.propTypes = {

};
